import React, { useCallback, useEffect, useMemo, useReducer } from 'react'
import useAbortController from '../../../../hooks/useAbortController';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from '@mui/material';
import { isLocalDev } from '../../../../utils/environment';
import { CustomerService } from '../../../../service/customerService';
import SelectableTable from '../../../enhancedTable/SelectableTable';

function InsuranceListDialog({ open, onClose, onSelect, customer }) {
    const [signal, abortRequest] = useAbortController();
    const [state, updateState] = useReducer((state, params) => {
        return { ...state, ...params };
    }, {
        data: [],
        totalRowCount: 0,
        pageCount: 0,
        filter: '',
        loading: false,
    });

    // this useeffect is used to abort the request when the component unmounts
    useEffect(() => {
        return () => {
            console.log('Cleaning up');
            if (!open)
                abortRequest();
        };
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: 'Provider',
                accessor: 'providerName',
            },
            {
                Header: 'Policy #',
                accessor: 'policyNumber',
            },
            {
                Header: 'Group #',
                accessor: 'groupNumber',
            },
            {
                Header: 'Actions',
                accessor: 'actions',
                Cell: ({ row }) => (
                    <Button
                        variant="text   "
                        color="primary"
                        onClick={() => handleSelect(row.original)}
                    >
                        Select
                    </Button>
                ),
            },
        ],
        []
    );

    const handleSelect = (supplier) => {
        onSelect(supplier);
        onClose();
    };

    const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
        const from = pageSize * pageIndex;
        updateState({ loading: true });
        CustomerService.getInsurancePolicies(from, pageSize, filters, sortBy, customer.customer.id, signal).then(result => {
            const { code, data } = result;
            if (code === 0) {
                updateState({
                    data: data.data,
                    totalRowCount: data.count,
                    pageCount: Math.ceil(data.count / pageSize),
                });
            }
            updateState({ loading: false });
        }).catch(error => {
            if (isLocalDev) {
                console.error(error)
            }
            updateState({ loading: false });
        });
    }, []);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>Insurance Policy for {customer.customer.fullName}</DialogTitle>
            <DialogContent>
                <Box>
                    <Typography variant="h4">Policies</Typography>
                    <Divider sx={{ mb: 2 }} />
                    <SelectableTable
                        columns={columns}
                        data={state.data}
                        totalRowCount={state.totalRowCount}
                        pageCount={state.pageCount}
                        fetchData={fetchData}
                        loading={state.loading}
                        disableSelection={true}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default InsuranceListDialog